<template>
  <div class="list">
    <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
      :loading-text="$t('Hint.loading')" immediate-check>
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap app_card">
          <div class="item_wrap_head">
            <div class="head_left">
              <div class="head_left_title" v-if="userInfo.id == item.buyer_id">{{ $t('买入余额') }}</div>
              <div class="head_left_title" v-if="userInfo.id == item.seller_id">{{ $t('卖出余额') }}</div>
              <div class="head_left_desc">{{ item.trade_no }}</div>
            </div>
            <div class="head_status">{{ getStatus(item.status) }}</div>
          </div>
          <div class="item_wrap_moneys">
            <div class="money_item">
              <div class="money_title">{{ $t('label.amount') }}</div>
              <div class="money_val">{{ $money(item.amount || '0.00') }}</div>
            </div>
          </div>
          <template v-if="item.status == 'cancelled'">
            <template v-if="item.cancel_reason == 'admin_cancelled'">
              <p v-if="item.admin_remark">{{ $t('取消原因') }}{{ item.admin_remark }}</p>
            </template>
            <template v-if="item.cancel_reason == 'buyer_cancelled'">
              <p>{{ $t('取消原因') }}{{ $t('买家取消') }}</p>
            </template>
            <template v-if="item.cancel_reason == 'payment_timeout'">
              <p>{{ $t('取消原因') }}{{ $t('支付超时') }}</p>
            </template>
          </template>
          <div class="btns">
            <template v-if="item.status == 'waiting_payment'">
              <div class="item_wrap_btn" @click="cancelOrder(item)"> {{ $t('My.Button.One') }} </div>
              <div class="item_wrap_btn paid" v-if="item.buyer_id == userInfo.id" @click="payment(item)">{{ $t('支付') }}
              </div>
            </template>
            <template v-else-if="item.status == 'paid'">
              <template v-if="item.seller_id == userInfo.id">
                <div class="item_wrap_btn paid" @click="submit(item)">{{ $t('My.Button.Two') }}</div>
                <div class="item_wrap_btn" @click="appeal(item)">{{ $t('申诉') }}</div>
              </template>
            </template>
          </div>
        </div>
      </template>
      <div class="list_not" v-else>
        <img :src="require('@/assets/Img/null/null.png')" alt="">
        <span>{{ $t('无我的订单') }}</span>
      </div>
    </List>
    <van-popup v-model="popShow" position="bottom" round>
      <div class="pop">
        <h2>{{ popItem.side == 'sell' ? $t('买入余额') : $t('卖出余额') }}</h2>
        <div class="c2c_field">
          <span>{{ $t('交易金额') }}(INR)</span>
          <van-field v-model="popItem.amount" readonly />
        </div>
        <div class="c2c_field">
          <span>{{ $t('收款信息') }}</span>
          <div class="cont_right">
            <template v-if="popItem?.payment?.open == 'crypto'">
              <div class="right_item">
                <span>{{ $t('钱包类型') }}:</span>{{ popItem?.payment?.name }}
              </div>
              <div class="right_item">
                <span>{{ $t('地址') }}:</span>{{ popItem?.payment?.card }}
              </div>
            </template>
            <template v-else>
              <div class="right_item">
                <span>{{ $t('用户名') }}:</span>{{ popItem?.payment?.name }}
              </div>
              <div class="right_item">
                <span>{{ $t('银行名称') }}:</span>{{ popItem?.payment?.open }}
              </div>
              <div class="right_item">
                <span>{{ $t('银行代码') }}:</span>{{ popItem?.payment?.card }}
              </div>
            </template>
          </div>
        </div>
        <div class="c2c_field">
          <span>{{ $t('交易凭证') }}</span>
          <van-uploader v-model="imgBack" :after-read="imgkUpload" :show-upload="imgBack.length === 0"
            @delete="deleteImage" :style="{
              width: 'calc(220rem / 32)',
              height: 'calc(220rem / 32)',
            }" />
        </div>
        <div class="btns">
          <div class="btn" @click="popShow = false">{{ $t('My.Button.One') }}</div>
          <div class="btn confirm" @click="popSubmit" :style="!payment_proof ? { opacity: .5 } : {}">{{
            $t('My.Button.Two')
          }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="dialogShow" position="center" round :style="{ width: '80%' }">
      <div class="dialog">
        <div class="dialog_title">{{ $t('确认订单') }}</div>
        <div class="dialog_pop">
          <span>{{ $t('交易凭证') }}</span>
          <img :src="$img(dialogItem.payment_proof)" alt="" @click="imgPreview">
        </div>
        <div class="dialog_pop">
          <span>{{ $t('交易密码') }}</span>
          <van-field v-model="paypass" :placeholder="$t('请输入交易密码')" />
        </div>
        <div class="dialog_btn">
          <div class="btn" @click="paypass = ''; dialogShow = false;">{{ $t('My.Button.One') }}</div>
          <div class="btn btn_confirm" @click="submitConfirm">{{ $t('My.Button.Two') }}</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="appealShow" position="center" round :style="{ width: '80%' }" autosize>
      <div class="dialog dialogs">
        <div class="dialog_title">{{ $t('申诉') }}</div>
        <div class="dialog_pop">
          <span>{{ $t('申诉原因') }}</span>
          <van-field v-model="reason" type="textarea" maxlength="500" show-word-limit rows="3"
            :placeholder="$t('请输入申诉原因')" />
        </div>
        <div class="dialog_btn">
          <div class="btn" @click="reason = ''; appealShow = false;">{{ $t('My.Button.One') }}</div>
          <div class="btn btn_confirm" @click="appealConfirm">{{ $t('My.Button.Two') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { List, Dialog, Toast, Popup, Field, Uploader, ImagePreview } from "vant";
import { post } from "@/utils/newRequest";
import { C2C_TRADE_CANCEL, C2C_TRADE_CONFIRM, C2C_TRADE_PAID, C2C_TRADE_APPEAL } from "@/api"
import { mapGetters } from "vuex";
import { $upload } from "@/utils/request.js";
export default {
  components: {
    List,
    Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      loadingRequest: false,
      hasMore: true,
      popShow: false,
      popItem: {},
      payment_proof: '',
      imgBack: [],
      dialogShow: false,
      paypass: '',
      dialogItem: {},
      appealShow: false,
      reason: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  
  methods: {
    getStatus(_status) {
      switch (_status) {
        case 'waiting_payment':
          return this.$t('未支付')
          break;
        case 'paid':
          return this.$t('待确认')
          break;
        case 'completed':
          return this.$t('完成')
          break;
        case 'cancelled':
          return this.$t('My.Button.One')
          break;
        case 'appealing':
          return this.$t('申诉')
          break;
        default:
          break;
      }
    },
    async compressImg(file) {
      const img = await this.readImg(file);
      const type = img.type;
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const { width: originWidth, height: originHeight } = img;
        // 最大尺寸限制
        const maxWidth = 1000;
        const maxHeight = 1000;
        // 目标尺寸
        let targetWidth = originWidth;
        let targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            //  宽图片
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            // 高图片
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, type || "image/png");
      });
    },
    imgPreview() {
      ImagePreview([this.$img(this.dialogItem.payment_proof)]);
    },
    async imgkUpload(event) {
      event.status = "uploading";
      event.message = this.$t("upload.uploading");
      const formdata = new FormData();
      try {
        const ImgData = await this.compressImg(event.file);
        const fileData = new File([ImgData], event.file.name, {
          type: ImgData.type,
        });
        formdata.append("image", fileData);
      } catch (error) {
        formdata.append("image", event.file);
      }
      $upload({ url: "/users/upload", data: formdata }).then((res) => {
        if (res.ret === 1) {
          event.status = "success";
          event.message = "";
          this.payment_proof = res.data.path;
        } else {
          event.status = "failed";
          event.message = this.$t("upload.failed");
        }
      }).catch((err) => {
        event.status = "failed";
        event.message = this.$t("upload.failed");
        // this.$toast(this.$t("uploadErr"));
      });
    },
    deleteImage() {
      (this.imgBack = []), (this.payment_proof = "");
    },
    async getList(lower = false) {
      if (this.loadingRequest) return;
      this.loadingRequest = true;
      if (!lower) {
        this.page++;
      }
      this.loading = true;
      try {
        const { lists, hasMorePages, total: _total } = await post("/c2c/my/trades", {
          pagesize: 20,
          page: this.page,
        });
        const realList = lists;
        this.hasMore = hasMorePages;
        if (lower) {
          this.list = [...realList]
        } else {
          this.list = [...this.list, ...realList];
        }
        this.loading = false;
        this.loadingRequest = false;
      } catch (error) {
        if (!lower) this.page--;
        this.loading = false;
        this.loadingRequest = false;
      }
    },
    cancelOrder(_item) {
      Dialog({
        title: this.$t('取消订单'),
        message: this.$t('确认取消该订单吗'),
        showCancelButton: true,
        cancelButtonText: this.$t('My.Button.One'),
        confirmButtonText: this.$t('My.Button.Two')
      }).then(async () => {
        Toast.loading();
        try {
          const res = await C2C_TRADE_CANCEL({
            id: _item.id
          });
          Toast.clear();
          Toast(res.msg);
          setTimeout(() => {
            this.$store.dispatch('getuserInfo')
            this.page = 0;
            this.getList(true);
          }, 500)
        } catch (error) {
          Toast.clear()
          error.msg && Toast(error.msg);
        }
      }).catch(() => { });
    },
    payment(_item) {
      this.popShow = true;
      this.popItem = _item;
    },
    async popSubmit() {
      if (!this.payment_proof) return;
      Toast.loading();
      try {
        const res = await C2C_TRADE_PAID({
          id: this.popItem.id,
          payment_proof: this.payment_proof
        });
        Toast.clear();
        Toast(res.msg);
        setTimeout(() => {
          this.popShow = false;
          this.page = 0;
          this.getList(true)
        }, 500)
      } catch (error) {
        Toast.clear()
        error.msg && Toast(error.msg)
      }
    },
    submit(_item) {
      this.dialogItem = _item;
      this.dialogShow = true;
    },
    async submitConfirm() {
      if (!this.paypass) return Toast(this.$t('请输入交易密码'));
      try {
        const res = await C2C_TRADE_CONFIRM({
          id: this.dialogItem.id,
          paypass: this.paypass
        })
        Toast(res.msg);
        setTimeout(() => {
          this.dialogShow = false;
          this.page = 0;
          this.getList(true)
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg)
      }
    },
    appeal(_item) {
      this.dialogItem = _item;
      this.appealShow = true;
    },
    async appealConfirm() {
      if (!this.reason) return Toast(this.$t('请输入申诉原因'));
      try {
        const res = await C2C_TRADE_APPEAL({
          id: this.dialogItem.id,
          reason: this.reason
        })
        Toast(res.msg);
        setTimeout(() => {
          this.appealShow = false;
          this.page = 0;
          this.getList(true)
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.list {
  :deep(.van-list) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .item_wrap {
    padding: 12px;
    border: 1px solid rgba(15, 23, 42, .06);
    border-radius: 14px;
    background: #fff;

    .item_wrap_head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;

      .head_left {

        .head_left_title {
          line-height: 1;
          color: #111827;
          font-size: 15px;
          font-weight: 900;
        }

        .head_left_desc {
          margin-top: 3px;
          color: #7a8597;
          font-size: 12px;
          font-weight: 800;
        }
      }

      .head_status {
        background: #2f82ff1a;
        color: #3f83ed;
        flex-shrink: 0;
        padding: 4px 8px;
        border-radius: 999px;
        font-size: 12px;
        font-style: normal;
        font-weight: 900;
      }
    }

    .item_wrap_moneys {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
      gap: 8px;
      margin-top: 10px;

      .money_item {
        padding: 9px 10px;
        border-radius: 12px;
        background: #f7f9fc;

        .money_title {
          color: #7a8597;
          font-size: 11px;
          font-weight: 800;
        }

        .money_val {
          margin-top: 4px;
          overflow: hidden;
          color: #111827;
          font-size: 12px;
          font-weight: 900;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    p {
      margin: 9px 0 0;
      padding: 8px 10px;
      border-radius: 12px;
      background: #ffb24d1f;
      color: #9a5d00;
      font-size: 12px;
      font-weight: 800;
    }

    .btns {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;

      .item_wrap_btn {
        flex: 1;
        height: 32px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e84f62;
        background: #fff;
        border-radius: 999px;
        border: 1px solid #e84f62;
        font-size: 14px;
      }

      .paid {
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        color: #0f172a;
        box-shadow: 0 9px 20px #31e2a547;
        border-color: transparent;
        font-weight: 600;
      }
    }
  }

  .list_not {
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 160px;
      height: 160px;
      display: block;
    }

    span {
      padding: 16px 0;
      color: #0f172a;
      font-size: 14px;
    }
  }
}

.pop {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 16px 30px;
  background: #f7f9fc;

  h2 {
    margin: 0;
    color: #111827;
    font-size: 20px;
    font-weight: 900;
  }

  p {
    margin: 6px 0 0;
    color: #697386;
    font-size: 13px;
    line-height: 1.5;
  }

  .c2c_preview {
    padding: 9px 10px;
    border-radius: 12px;
    background: #f7f9fc;

    span {
      color: #7a8597;
      font-size: 11px;
      font-weight: 800;
    }

    div {
      margin-top: 4px;
      overflow: hidden;
      color: #111827;
      font-size: 12px;
      font-weight: 900;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .c2c_field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    >span {
      color: #566071;
      font-size: 12px;
      font-weight: 600;
    }

    :deep(.van-field) {
      line-height: 42px;
      height: 42px;
      padding: 0 12px;
      border: 1px solid rgba(15, 23, 42, .08);
      border-radius: 12px;
      background: #fff;
      color: #111827;
      font-size: 14px;
      font-weight: 600;
    }

    .cont_right {
      flex: 1;
      background: #fff;
      padding: 12px;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .right_item {
        font-size: calc(14rem / 16);
        color: #111827;
        font-weight: 600;

        span {
          color: #566071;
          font-size: 14px;
          margin-right: calc(5rem / 16);
        }
      }
    }
  }

  .btns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    .btn {
      height: 44px;
      border-radius: 1000px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      font-size: 14px;
      background: #fff;
      color: #323233;
      border: 1px solid #dcdee0;
    }

    .confirm {
      background: linear-gradient(90deg, #8ff5d1, #31e2a5);
      border-color: transparent;
      color: #064b38;
      font-weight: 800;
      box-shadow: 0 9px 20px #31e2a547;
    }
  }
}

.dialog {
  padding: 16px;
  display: grid;
  gap: 10px;

  .dialog_title {
    color: #0f172a;
    font-weight: 600;
    text-align: center;
    font-size: 16px;
  }

  .dialog_pop {
    display: flex;
    flex-direction: column;
    gap: 6px;

    >span {
      color: #566071;
      font-size: 14px;
      font-weight: 600;
    }

    :deep(.van-field) {
      line-height: 42px;
      height: 42px;
      padding: 0 12px;
      border: 1px solid rgba(15, 23, 42, .08);
      border-radius: 12px;
      background: #fff;
      color: #111827;
      font-size: 14px;
      font-weight: 600;
    }

    img {
      width: 120px;
      height: 120px;
      display: block;
      border-radius: 10px;
    }
  }

  .dialog_btn {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-top: 10px;

    .btn {
      font-size: 14px;
      height: 42px;
      background: #fff;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #323233;
      border: 1px solid #dcdee0;
    }

    .btn_confirm {
      background: linear-gradient(90deg, #8ff5d1, #31e2a5);
      color: #064b38;
      font-weight: 600;
    }
  }

}

.dialogs {
  :deep(.van-field) {
    line-height: inherit !important;
    height: inherit !important;
    padding-top: 4px !important;
  }
}
</style>